export default __webpack_public_path__ + "static/media/pantry1-afterB-768w.6cd3b839.png";